import _ from 'lodash';

/**
 * Returns a price with the $ and appropriate number of digits.
 *
 * @param price
 */
export const format = (price: number | string): string => {
    const priceNumber = typeof price === 'string' ? parseFloat(price) : price;
    const formatted = priceNumber.toLocaleString('en-US', {
        currency: 'USD',
        minimumFractionDigits: 2
    });

    return `$${formatted}`;
};

export const getPrice = (item: any) => {

    // not sure why buy MSLP comes out as "1" rather than 1 so I added both to be sure...
    if ((_.get(item, 'field_instr_mslp_cbox.value') === 1 || _.get(item, 'field_instr_mslp_cbox.value') === '1') && _.get(item, 'field_instr_mslp.value')) {
        return parseFloat(item.field_instr_mslp.value);
    }
    if (_.get(item, 'field_instr_map_cbox.value') === 1 && _.get(item, 'field_instr_map.value')) {
        return parseFloat(item.field_instr_map.value);
    }

    return parseFloat(item.field_instr_asking_price ? item.field_instr_asking_price.value : 0);
};

/**
 * Render the price number for display
 * heirachry = MSLP, MAP, asking price - was not confirmed by client Nov-02-2018
 */
export const renderPrice = (item: any) => {
    function formatPrice() {
        // not sure why buy MSLP comes out as "1" rather than 1 so I added both to be sure...
        if ((_.get(item, 'field_instr_mslp_cbox.value') === 1 || _.get(item, 'field_instr_mslp_cbox.value') === '1') && _.get(item, 'field_instr_mslp.value')) {
            return `MSLP ${format(item.field_instr_mslp.value)}`;
        }
        if (_.get(item, 'field_instr_map_cbox.value') === 1 && _.get(item, 'field_instr_map.value')) {
            return `${format(item.field_instr_map.value)}`;
        }

        return item.field_instr_asking_price ? format(item.field_instr_asking_price.value) : 'Inquire for pricing';
    }

    switch (item.state) {
        case 'Available':
            return formatPrice();
        case 'Sold':
            return 'Sold';
        case 'Hold':
            return 'On hold';
        default:
            return 'Not for sale';
    }
};



// WEBPACK FOOTER //
// ./src/contexts/prices.ts